import React, { useState, useEffect, useContext } from "react";
import { UserContext, getCurrentToken } from "./context/UserContext";
import { useNavigate } from "react-router-dom";
import requests from "./base";
import { MaterialReactTable } from "material-react-table";
import { Box, Button, Typography } from "@mui/material";

const Dashboard = () => {
  const { signOut } = useContext(UserContext);
  const navigate = useNavigate();
  const [vendorEmail, setVendorEmail] = useState("");
  const [products, setProducts] = useState([]);
  const [services, setServices] = useState([]);
  const [vendorData, setVendorOrders] = useState([]);
  const [productCount, setProductCount] = useState(0);
  const [servuceCount, setserviceCount] = useState(0);
  const [oderCount, setVendorOrdersCount] = useState([]);
   const [oderCountdelivered, setVendorOrdersCountdelivered] = useState([]);
  const [vendorSale, setVendorSale] = useState([]);
  const [loading, setLoading] = useState(true);
  const [vendorProducts, setVendorProducts] = useState([]);

  useEffect(() => {
    const checkToken = async () => {
      const token = getCurrentToken();
      if (!token) {
        navigate("/login");
      } else {
        setVendorEmail(token.Data.FirstName);
        await fetchProducts();
        setLoading(false);

        await fetchProducts();
        await fetchServicess();

        const count = await fetchProductsCount();
        setProductCount(count);
        const counts = await fetchSrvicesCount();
        setserviceCount(counts);
        const countorder = await fetchOrdersCount();
        setVendorOrdersCount(countorder);
        const countorderdelivered = await fetchOrdersCountDelivered();
        setVendorOrdersCountdelivered(countorderdelivered);
        const tokenResponse = getCurrentToken();

        const userToken = tokenResponse.Data.Token;
        await fetchVendorSalesById(userToken);
        setLoading(false);
      }
    };
    checkToken();
  }, [navigate]);

  // Fetch products from backend API
  const fetchProducts = async () => {
    try {
      const token = getCurrentToken();
      const vendorID = token.Data.UserId;
      const response = await requests.get(
        `/getvendorproductsbyvendorID?VendorID=${vendorID}`
      );
      if (response?.Data) {
        setProducts(response.Data);
      }
    } catch (error) {
      console.error("Failed to fetch products:", error);
    }
  };

  const fetchServicess = async () => {
    try {
      const token = getCurrentToken();
      const vendorID = token.Data.UserId;
      const response = await requests.get(
        `/getvendorServicesbyvendorID?VendorID=${vendorID}`
      );
      if (response?.Data) {
        setServices(response.Data);
      }
    } catch (error) {
      console.error("Failed to fetch products:", error);
    }
  };

  // counting Start

  const fetchProductsCount = async () => {
    try {
      const token = getCurrentToken();
      const vendorID = token.Data.UserId;
      const response = await requests.get(
        `/getvendorproductsbyvendorID?VendorID=${vendorID}`
      );
      if (response?.Data) {
        return response.Data.length; // Return total number of items
      } else {
        return 0; // If no data returned
      }
    } catch (error) {
      console.error("Failed to fetch products:", error);
      return 0; // Return 0 on error
    }
  };

  const fetchSrvicesCount = async () => {
    try {
      const token = getCurrentToken();
      const vendorID = token.Data.UserId;
      const response = await requests.get(
        `/getvendorServicesbyvendorID?VendorID=${vendorID}`
      );
      if (response?.Data) {
        return response.Data.length; // Return total number of items
      } else {
        return 0; // If no data returned
      }
    } catch (error) {
      console.error("Failed to fetch products:", error);
      return 0; // Return 0 on error
    }
  };

  const fetchOrdersCount = async () => {
    try {
      const token = getCurrentToken();
      const vendorID = token.Data.UserId;
      const response = await requests.get(
        `/getvendorSalesbyvendorID?vendorid=${vendorID}`
      );
      if (response?.Data) {
        return response.Data.length; // Return total number of items
      } else {
        return 0; // If no data returned
      }
    } catch (error) {
      console.error("Failed to fetch products:", error);
      return 0; // Return 0 on error
    }
  };

  const fetchOrdersCountDelivered = async () => {
  try {
    const token = getCurrentToken();
    const vendorID = token.Data.UserId;

    const response = await requests.get(
      `/getvendorSalesbyvendorID?vendorid=${vendorID}`
    );

    if (response?.Data) {
      // Filter only delivered orders
      const deliveredOrders = response.Data.filter(
        (order) => order.OrderStatus === "Delivered"
      );
      return deliveredOrders.length;
    } else {
      return 0;
    }
  } catch (error) {
    console.error("Failed to fetch orders:", error);
    return 0;
  }
};


  const fetchVendorSalesById = async (userToken) => {
    try {
      const token = getCurrentToken();
      const vendorID = token.Data.UserId;

      const response = await requests.get(
        `/getvendorSalesbyvendorID?vendorid=${vendorID}`
      );
      const vendorSales = response.Data || [];

      // For each order, fetch totalAmount from getSalesByOrderID
      const updatedSales = await Promise.all(
        vendorSales.map(async (order) => {
          try {
            const salesResponse = await requests.get(
              `/getSalesByOrderID?orderID=${order.ID}`
            );
            const salesData = salesResponse.Data || [];
            const totalAmount = salesData.reduce(
              (sum, item) => sum + parseFloat(item.Amount || 0),
              0
            );
            const totalItems = salesData.length;

            return {
              ...order,
              TotalAmount: totalAmount,
              TotalItems: totalItems,
            };
          } catch (err) {
            console.error(`Failed to get sales for order ID ${order.ID}`, err);
            return { ...order, TotalAmount: 0, TotalItems: 0 };
          }
        })
      );

      setVendorSale(updatedSales);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      accessorKey: "Description",
      header: "Order No",
      Cell: ({ row }) => {
        const description = row.original.Description;
        const totalItems = row.original.TotalItems || 0; // fallback if missing
        return (
          <Box>
            <Typography variant="body1" fontWeight="bold">
              {description}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {totalItems} item{totalItems !== 1 ? "s" : ""}
            </Typography>
          </Box>
        );
      },
    },

    {
      accessorKey: "OrderStatus",
      header: "Status",
      Cell: ({ cell }) => {
        const status = cell.getValue();

        let iconClass = "";
        let bgColor = "";
        let textColor = "";

        if (status === "Pending") {
          iconClass = "mdi mdi-clock-outline";
          bgColor = "#FFF9E6";
          textColor = "#C77800";
        } else if (status === "Delivered") {
          iconClass = "mdi mdi-check";
          bgColor = "#E6F9EC";
          textColor = "#007E33";
        } else if (status === "Canceled") {
          iconClass = "mdi mdi-close";
          bgColor = "#FCEBEC";
          textColor = "#D32F2F";
        } else if (status === "Processing") {
          iconClass = "mdi mdi-clock-outline";
          bgColor = "#E6F1FF";
          textColor = "#1565C0";
        } else if (status === "Returned") {
          iconClass = "mdi mdi-clock-outline";
          bgColor = "#E6F1FF";
          textColor = "#0D1B2A";
        }

        return (
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              backgroundColor: bgColor,
              color: textColor,
              px: 1.5,
              py: 0.5,
              borderRadius: "10px",
              fontWeight: "bold",
              fontSize: "14px",
            }}
          >
            <span className={iconClass} style={{ fontSize: "18px" }}></span>
            {status}
          </Box>
        );
      },
    },

    {
      header: "Clent Name",
      accessorFn: () => "John Doe",
      id: "ClientName",
      Cell: ({ cell }) => <span>{cell.getValue()}</span>,
    },

    {
      accessorKey: "CreatedDate",
      header: "Date Ordered",
      Cell: ({ cell }) => {
        const rawDate = cell.getValue();
        const date = new Date(rawDate);
        const formatted = date.toLocaleDateString("en-GB", {
          month: "short",
          day: "2-digit",
          year: "numeric",
        });
        return formatted;
      },
    },

    {
      accessorKey: "TotalAmount",
      header: "Total Amount",
      Cell: ({ cell }) => `Ksh${parseFloat(cell.getValue()).toFixed(2)}`, // currency format
    },
  ];

  if (loading) return <div>Loading...</div>;
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good Morning";
    if (hour < 18) return "Good Afternoon";
    return "Good Evening";
  };
  return (
    <>
      <div className="container mt-4 me-4">
        <div className="row">
          <div
            className="card d-flex flex-row align-items-center p-3 border-0"
            style={{ height: "70px", width: "100%" }}
          >
            <div className="flex-grow-1">
              <h3 className="mb-0 fw-bold">
                {getGreeting()}, {vendorEmail}👋 You have:
              </h3>
            </div>
            <img
              src="../acre-africa-logo.svg"
              alt="User"
              className="rounded-circle"
              style={{ width: "40px", height: "40px", objectFit: "cover" }}
            />
          </div>
        </div>
      </div>

      <div className="container mt-4">
        {/* Row of 4 cards */}
        <div className="row">
          {/* Card 1 */}

          <div className="col-md-3">
            <div className="card text-dark bg-white  mb-3 border-0">
              <div className="card-body">
                <p className="card-text fw-bold">Total Products</p>
                <h1 className="card-title fw-bolder text-info">
                  {productCount}
                </h1>
                <span className="card-text smaller-text text-secondary">
                  Registered users on the platform
                </span>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-3">
            <div className="card text-dark bg-white  mb-3 border-0">
              <div className="card-body ">
                <p className="card-text fw-bold">Total Services</p>
                <h1 className="card-title fw-bolder text-danger">
                  {servuceCount}
                </h1>
                <span className="card-text smaller-text">
                  Registered users on the platform
                </span>
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="col-md-3">
            <div className="card text-dark bg-white  mb-3 border-0">
              <div className="card-body">
                <p className="card-text fw-bold">Total Orders </p>
                <h1 className="card-title fw-bolder text-primary">
                  {oderCount}
                </h1>
                <span className="card-text smaller-text text-success">
                  Registered users on the platform
                </span>
              </div>
            </div>
          </div>

          {/* Card 4 */}
          <div className="col-md-3">
            <div className="card text-dark bg-white  mb-3 border-0">
              <div className="card-body">
                <p className="card-text fw-bold">Sales Delivered</p>
                <h1
                  className="card-title fw-bolder"
                  style={{ color: "#f5821f" }}
                >
                   {oderCountdelivered}
                </h1>
                <span
                  className="card-text smaller-text "
                  style={{ color: "#f5821f" }}
                >
                  Registered users on the platform
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Orders table and Status card below */}
        <div className="row">
          {/* Left: Table */}
          <div className="col-md-8">
            <div
              style={{
                padding: "0px 20px 20px 20px",
                backgroundColor: "#fff",
                borderRadius: "8px",
                parding: "20px",
              }}
            >
              <h5>Recent Orders</h5>
              <Box className="container mt-4">
                <Box>
                  <MaterialReactTable
                    columns={columns}
                    data={vendorSale}
                    // enablePagination
                    // enableRowHover
                    // enableColumnResizing
                    // enableSorting
                    muiTableContainerProps={{ sx: { maxHeight: "auto" } }}
                    muiTableBodyCellProps={{ sx: { fontSize: "14px" } }}
                    enableExpandAll={false}
                  />
                </Box>
              </Box>
              <div className="text-center " style={{ marginTop: "30px" }}>
                <a
                  href="/orders"
                  style={{
                    color: "black",
                    textDecoration: "none",
                    borderRadius: "20px",
                    marginTop: "10px",
                    backgroundColor: "rgb(230, 229, 229)",
                    padding: "4px 10px 4px 10px",
                    fontWeight: "10px",
                  }}
                >
                  view all
                </a>
              </div>
            </div>
          </div>

          {/* Right: Two stacked cards */}
          <div className="col-md-4 d-flex flex-column gap-3">
            {/* First Card */}
            <div className="card border-0">
              <div
                className="card-header bg-white text-dark"
                style={{ borderBottom: "none" }}
              >
                <h5 className="fw-bold">Recenctly Added Products</h5>
              </div>
              <div className="card-body p-0">
                {products.length === 0 ? (
                  <div className="text-center text-muted p-3">
                    No products added yet
                  </div>
                ) : (
                  <>
                    <ul className="list-group">
                      {products
                        .sort((a, b) => b.ID - a.ID)
                        .slice(0, 3)
                        .map((product) => {
                          const status = product.status;
                          // Check if status is "Pending" or "Approved"
                          const isPending = status.toLowerCase() === "pending";
                          const isApproved =
                            status.toLowerCase() === "approved";

                          // Optional: You can decide what to do for other statuses
                          // For now, just show the status label if it's Pending or Approved, otherwise show nothing or the raw status
                          const showStatus = isPending || isApproved;

                          return (
                            <li
                              key={product.ID}
                              className="list-group-item d-flex justify-content-between align-items-center"
                              style={{ border: "none" }}
                            >
                              <div
                                className="d-flex justify-content-between align-items-center"
                                style={{
                                  backgroundColor: "rgb(245, 242, 242)",
                                  width: "100%",
                                  padding: "4px 7px",
                                  borderRadius: "5px",
                                }}
                              >
                                <div>
                                  <div
                                    className="fw-bold"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {product.ProductName}
                                  </div>
                                  <small
                                    className="text-muted"
                                    style={{ fontSize: "11px" }}
                                  >
                                    Submitted on Feb 19, 2025
                                  </small>
                                </div>
                                {showStatus && (
                                  <span
                                    style={{
                                      color: isPending
                                        ? "#f5821f"
                                        : "rgb(1, 181, 64)",
                                      backgroundColor: isPending
                                        ? "#fff3e6"
                                        : "#e6ffe6",
                                      borderRadius: "20px",
                                      padding: "3px 10px",
                                      fontSize: "12px",
                                      display: "inline-block",
                                      minWidth: "90px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {status}
                                  </span>
                                )}
                              </div>
                            </li>
                          );
                        })}
                    </ul>

                    {/* Show More Link - only when there are products */}
                    <div className="text-center mt-2 me-3">
                      <a href="/Products" style={{ color: "#f5821f" }}>
                        view all
                      </a>
                    </div>
                  </>
                )}
              </div>
            </div>
            {/* second card */}
            
            
             <div className="card border-0">
              <div
                className="card-header bg-white text-dark"
                style={{ borderBottom: "none" }}
              >
                <h5 className="fw-bold">Recenctly Added Services</h5>
              </div>
              <div className="card-body p-0">
                {services.length === 0 ? (
                  <div className="text-center text-muted p-3">
                    No Services yet added yet
                  </div>
                ) : (
                  <>
                    <ul className="list-group">
                      {services
                        .sort((a, b) => b.ID - a.ID)
                        .slice(0, 3)
                        .map((service) => {
                          const status = service.Status;
                          // Check if status is "Pending" or "Approved"
                          const isPending = status.toLowerCase() === "pending";
                          const isApproved =
                            status.toLowerCase() === "approved";

                          // Optional: You can decide what to do for other statuses
                          // For now, just show the status label if it's Pending or Approved, otherwise show nothing or the raw status
                          const showStatus = isPending || isApproved;

                          return (
                            <li
                              key={service.ID}
                              className="list-group-item d-flex justify-content-between align-items-center"
                              style={{ border: "none" }}
                            >
                              <div
                                className="d-flex justify-content-between align-items-center"
                                style={{
                                  backgroundColor: "rgb(245, 242, 242)",
                                  width: "100%",
                                  padding: "4px 7px",
                                  borderRadius: "5px",
                                }}
                              >
                                <div>
                                  <div
                                    className="fw-bold"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {service.ServiceName}
                                  </div>
                                  <small
                                    className="text-muted"
                                    style={{ fontSize: "11px" }}
                                  >
                                    Submitted on Feb 19, 2025
                                  </small>
                                </div>
                                {showStatus && (
                                  <span
                                    style={{
                                      color: isPending
                                        ? "#f5821f"
                                        : "rgb(1, 181, 64)",
                                      backgroundColor: isPending
                                        ? "#fff3e6"
                                        : "#e6ffe6",
                                      borderRadius: "20px",
                                      padding: "3px 10px",
                                      fontSize: "12px",
                                      display: "inline-block",
                                      minWidth: "90px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {status}
                                  </span>
                                )}
                              </div>
                            </li>
                          );
                        })}
                    </ul>

                    {/* Show More Link - only when there are products */}
                    <div className="text-center mt-2 me-3">
                      <a href="/Products" style={{ color: "#f5821f" }}>
                        view all
                      </a>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Second Card */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
